module.exports = __webpack_public_path__ + "img/task-manager-icon-active.bf3cf7af.svg";